import axios from "axios";

// When REACT_APP_BACKEND_URL is empty/undefined, axios will issue requests
// relative to the current page origin — required for reverse-proxy deployments
// like https://besi.besikoscars.gr which forwards /api to the backend.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

// Auth is handled exclusively via httpOnly cookies set by the backend on /auth/login.
// `withCredentials: true` ensures the cookie travels with every request.
export const api = axios.create({
  baseURL: API,
  timeout: 60000,
  withCredentials: true,
});

// Auto-redirect on 401 (except for /auth/me & /auth/login probes themselves)
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const url = error?.config?.url || "";
    if (
      error?.response?.status === 401 &&
      !url.includes("/auth/me") &&
      !url.includes("/auth/login")
    ) {
      if (window.location.pathname !== "/login" && !window.location.pathname.startsWith("/presentation/") && window.location.pathname !== "/sell-my-car") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export const PHOTO_URL = (rel) => {
  if (!rel) return "";
  if (rel.startsWith("http")) return rel;
  return `${BACKEND_URL}${rel}`;
};
